import { render, staticRenderFns } from "./ByRevo.vue?vue&type=template&id=5f38cd14"
import script from "./ByRevo.vue?vue&type=script&lang=js"
export * from "./ByRevo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports